import '../styles/loader.css'

export default function Loader() {
  return (
    <>
      <div className="loader__container">
        <div className='loader'>
          <span>L</span>
          <span>O</span>
          <span>A</span>
          <span>D</span>
          <span>I</span>
          <span>N</span>
          <span>G</span>
        </div>
      </div>
    </>
  )
}
